<template>
  <div class="header row align-center">
    <div class="menu-mobile show-s grid-2-s" @click="showMenu = !showMenu">
      <button :class="showMenu ? 'close' : ''"></button>
      <ul class="menu column" :class="showMenu ? 'opened' : ''">
        <li v-if="m.includes('financeiro')">
          <router-link to="/funcionario/analise-receita">ANÁLISE DE RECEITA</router-link>
        </li>
        <li>
          <router-link to="/funcionario/acompanhamento">ACOMPANHAMENTO</router-link>
        </li>
        <li v-if="m.includes('jobs')"><router-link to="/funcionario/jobs">JOBS</router-link></li>
        <li>
          <router-link to="/funcionario/parceiros">PARCEIROS</router-link>
        </li>
        <li class="row">
          OUTROS
          <ul>
            <li v-if="m.includes('materiais')">
              <router-link to="/funcionario/materiais">Materiais</router-link>
            </li>
            <li v-if="m.includes('candidato-supporter')">
              <router-link to="/funcionario/candidatos-supporter">Candidatos</router-link>
            </li>
            <li v-if="m.includes('contratos')">
              <router-link to="/funcionario/contratos">Contratos</router-link>
            </li>
            <li v-if="m.includes('comunicados')">
              <router-link to="/funcionario/comunicados">Comunicados</router-link>
            </li>
            <li v-if="m.includes('flag')">
              <router-link to="/funcionario/flags">FLAGS</router-link>
            </li>
            <li>
              <router-link to="/funcionario/importacoes">Importações</router-link>
            </li>
            <li v-if="m.includes('permissoes') || user.grupo == 'TI'">
              <router-link to="/funcionario/permissoes">Permissões</router-link>
            </li>
            <li v-if="m.includes('pendencia-supporter') || m.includes('pendencia')">
              <router-link to="/funcionario/pendencias">Pendências</router-link>
            </li>
            <li @click="modal.show = true; modal.tab = 'comp'">
              Competências
            </li>
            <li @click="modal.show = true; modal.tab = 'cert'">
              Certificados
            </li>
            <li @click="modal.show = true; modal.tab = 'tool'">
              Ferramentas
            </li>
          </ul>
        </li>
        <li v-if="m.includes('supporter')">
          <router-link to="/funcionario/supporters">SUPPORTERS</router-link>
        </li>
        <li v-if="m.includes('nuh')">
          <router-link to="/funcionario/nuh">NUH</router-link>
        </li>
        <li v-if="m.includes('vtal')">
          <router-link to="/funcionario/vtal">VTAL</router-link>
        </li>
        <li v-if="m.includes('cliente')">
          <router-link to="/funcionario/clientes">CLIENTES</router-link>
        </li>
        <li v-if="m.includes('funcionario')">
          <router-link to="/funcionario/lista">FUNCIONÁRIOS</router-link>
        </li>
        <li v-if="m.includes('orientacao-padrao-ns') || m.includes('orientacoes-clientes')">
          <router-link to="/funcionario/orientacoes">ORIENTAÇÔES</router-link>
        </li>
        <li v-if="m.includes('financeiro')">
          <router-link to="/funcionario/notas-fiscais">NOTAS FISCAIS</router-link>
        </li>
        <li v-if="m.includes('financeiro')">
          <router-link to="/funcionario/pagamentos">PAGAMENTOS</router-link>
        </li>
        <li v-if="m.includes('financeiro')">
          <router-link to="/funcionario/financeiro/retorno">RETORNO &nbsp;
            <NewMark />
          </router-link>
        </li>
        <li v-if="m.includes('financeiro')">
          <router-link to="/funcionario/extrato-supporter">EXTRATO SUPPORTER &nbsp;
            <NewMark />
          </router-link>
        </li>
        <!--     <li>
          <router-link to="/funcionario/relatorio/conta-azul">CONTA AZUL</router-link>
        </li> -->
        <li v-if="m.includes('financeiro')">
          <router-link to="/funcionario/relatorio/fluxo-caixa">FLUXO DE CAIXA</router-link>
        </li>
        <li v-if="m.includes('base-custo')">
          <router-link to="/funcionario/base-custos">BASE DE CUSTOS</router-link>
        </li>
        <li>
          <router-link to="/funcionario/competencias-certificados-ferramentas">
            ESPECIALIDADES, CERTIFICADOS E FERRAMENTAS</router-link>
        </li>
        <li @click="SET_LOGOUT()">SAIR</li>
      </ul>
    </div>

    <div class="row grid-2-g grid-1-m grid-8-s align-center">
      <img src="../assets/img/logo26.svg" class="logo show-g" alt="Logo NetSupport" />
      <img src="../assets/img/logo26.svg" class="logo-icon hide-g" alt="NetSupport" />
    </div>

    <div class="grid-10 hide-s">
      <ul class="menu row hide-s justify-around">
        <li :class="menu.attendance ? 'active' : ''" @click="() => changeMenu('attendance')">
          <router-link to="/funcionario/acompanhamento">ACOMPANHAMENTO</router-link>
        </li>
        <li v-if="m.includes('jobs')" :class="menu.jobs ? 'active' : ''" @click="() => changeMenu('jobs')">
          <router-link to="/funcionario/jobs">JOBS</router-link>
        </li>
        <li class="row">
          SUPPORTERS
          <ul>
            <li v-if="m.includes('supporter')" :class="menu.supporters ? 'active' : ''"
              @click="() => changeMenu('supporters')">
              <router-link to="/funcionario/supporters">SUPPORTERS</router-link>
            </li>
            <li v-if="m.includes('candidato-supporter')" :class="menu.candidates ? 'active' : ''"
              @click="() => changeMenu('candidates')">
              <router-link to="/funcionario/candidatos-supporter">CANDIDATOS</router-link>
            </li>
            <li v-if="m.includes('contratos')" @click="() => changeMenu('contratos')"
              :class="menu.contratos ? 'active' : ''">
              <router-link to="/funcionario/contratos">Contratos</router-link>
            </li>
            <li v-if="m.includes('pendencia-supporter') || m.includes('pendencia')"
              :class="menu.pendencies ? 'active' : ''" @click="() => changeMenu('pendencies')">
              <router-link to="/funcionario/pendencias">PENDÊNCIAS</router-link>
            </li>
            <li :class="menu.compCertTool ? 'active' : ''" @click="() => changeMenu('compCertTool')">
              <router-link to="/funcionario/certificados-ferramentas" style="font-size: 12px">ESPECIALIDADES,
                CERTIFICADOS E FERRAMENTAS</router-link>
            </li>
          </ul>
        </li>
        <li class="row">
          CLIENTES
          <ul>
            <li v-if="m.includes('cliente')" :class="menu.clients ? 'active' : ''" @click="() => changeMenu('clients')">
              <router-link to="/funcionario/clientes">LISTA</router-link>
            </li>
            <li v-if="m.includes('nuh') || user.grupo == 'TI'" :class="menu.nuh ? 'active' : ''"
              @click="() => changeMenu('nuh')">
              <router-link to="/funcionario/nuh">NUH</router-link>
            </li>
            <li v-if="m.includes('vtal') || user.grupo == 'TI'" :class="menu.vtal ? 'active' : ''"
              @click="() => changeMenu('vtal')">
              <router-link to="/funcionario/vtal">VTAL</router-link>
            </li>
          </ul>
        </li>
        <li class="row">
          FINANCEIRO
          <NewMark text="NOVO" />
          <ul>
            <li v-if="m.includes('financeiro')" :class="menu.analise ? 'active' : ''"
              @click="() => changeMenu('analise')">
              <router-link to="/funcionario/analise-receita">ANÁLISE DE RECEITA</router-link>
              <NewMark />
            </li>
            <li v-if="m.includes('base-custo')" :class="menu.costBase ? 'active' : ''"
              @click="() => changeMenu('costBase')">
              <router-link to="/funcionario/base-custos">BASE DE CUSTOS</router-link>
            </li>
            <!-- <li :class="menu.report ? 'active' : ''" @click="() => changeMenu('report')">
              <router-link to="/funcionario/relatorio/conta-azul">CONTA AZUL</router-link>
            </li> -->
            <li :class="menu.extractSupporter ? 'active' : ''" @click="() => changeMenu('extractSupporter')">
              <router-link to="/funcionario/extrato-supporter">EXTRATO SUPPORTER &nbsp;
                <NewMark />
              </router-link>
            </li>
            <li v-if="m.includes('financeiro')" :class="menu.cashflow ? 'active' : ''"
              @click="() => changeMenu('cashflow')">
              <router-link to="/funcionario/relatorio/fluxo-caixa">FLUXO DE CAIXA</router-link>
            </li>
            <li v-if="m.includes('financeiro')" :class="menu.nf ? 'active' : ''" @click="() => changeMenu('nf')">
              <router-link to="/funcionario/notas-fiscais">NOTAS FISCAIS</router-link>
            </li>
            <li v-if="m.includes('financeiro')" :class="menu.payment ? 'active' : ''"
              @click="() => changeMenu('payment')">
              <router-link to="/funcionario/pagamentos">PAGAMENTOS</router-link>
            </li>
            <li v-if="m.includes('financeiro')" :class="menu.retorno ? 'active' : ''"
              @click="() => changeMenu('retorno')">
              <router-link to="/funcionario/retorno">RETORNO &nbsp;
                <NewMark />
              </router-link>
            </li>
          </ul>
        </li>

        <li class="row" :class="menu.shortcut ? 'active' : ''" v-if="user.perfil">
          OUTROS
          <i class="arrow-down fa fa-chevron-down"></i>
          <ul>
            <li v-if="user.grupo == 'TI' || m.includes('materiais')" :class="menu.materiais ? 'active' : ''"
              @click="() => changeMenu('materiais')">
              <router-link to="/funcionario/materiais">MATERIAIS</router-link>
            </li>
            <li v-if="user.grupo == 'TI'" :class="menu.funcionarios ? 'active' : ''"
              @click="() => changeMenu('funcionarios')">
              <router-link to="/funcionario/lista">FUNCIONÁRIOS</router-link>
            </li>
            <li v-if="m.includes('comunicados')" :class="menu.communication ? 'active' : ''"
              @click="() => changeMenu('communication')">
              <router-link to="/funcionario/comunicados">COMUNICADOS</router-link>
            </li>
            <li v-if="m.includes('flag')" :class="menu.flags ? 'active' : ''" @click="() => changeMenu('flags')">
              <router-link to="/funcionario/flags">FLAGS</router-link>
            </li>
            <li :class="menu.imports ? 'active' : ''" @click="() => changeMenu('imports')">
              <router-link to="/funcionario/importacoes">IMPORTAÇÕES</router-link>
            </li>
            <li v-if="m.includes('orientacao-padrao-ns') || m.includes('orientacoes-clientes')"
              :class="menu.guidelines ? 'active' : ''" @click="() => changeMenu('guidelines')">
              <router-link to="/funcionario/orientacoes">ORIENTAÇÕES</router-link>
            </li>
            <li :class="menu.partner ? 'active' : ''" @click="() => changeMenu('partner')">
              <router-link to="/funcionario/parceiros">PARCEIROS</router-link>
            </li>
            <li v-if="m.includes('permissoes') || user.grupo == 'TI'" :class="menu.permissions ? 'active' : ''"
              @click="() => changeMenu('permissions')">
              <router-link to="/funcionario/permissoes">PERMISSÕES</router-link>
            </li>
            <li v-if="m.includes('tipo-servico')" :class="menu.servicesType ? 'active' : ''"
              @click="() => changeMenu('servicesType')">
              <router-link to="/funcionario/tipo-servicos">TIPOS DE SERVIÇOS</router-link>
            </li>
          </ul>
        </li>

      </ul>
    </div>
    <div class="grid-2 row align-center justify-end">
      <SLA v-if="user.grupo == 'Gestor de Demanda' || user.grupo == 'Gestor de Operação'" />
      <Notify />
    </div>
    <div class="userTab grid-2-g grid-3-m hide-s">
      <UserTab />
      <!-- <UserTab perfil="/cliente/perfil" account="/cliente/conta" /> -->
    </div>
  </div>
</template>

<script>
import UserTab from "@/components/UserTab.vue";
import NewMark from "@/components/NewMark.vue";
import Notify from "@/components/Notify.vue";
import SLA from "@/components/SLA.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";

var initMenu = {
  shortcut: false,
  clients: false,
  newJob: false,
  attendance: false,
  communication: false,
  nf: false,
  compCertTool: false,
  candidates: false,
  pendencies: false,
  servicesType: false,
  partners: false,
  guidelines: false,
  bank: false,
  payment: false,
  flags: false,
  report: false,
  cashflow: false,
  costBase: false,
  supporters: false,
  extractSupporter: false,
  funcionarios: false,
  retorno: false,
  analise: false,
  jobs: false,
  contratos: false,
  nuh: false,
  vtal: false,
  materiais: false
};
export default {
  name: "HeaderAdmin",
  components: {
    UserTab,
    Notify,
    SLA,
    NewMark,
  },
  data() {
    return {
      showMenu: false,
      menu: initMenu,
      m: []
    };
  },

  methods: {
    ...mapActions("user", ["SET_LOGOUT"]),
    ...mapActions("admin", ["MENU", "LOAD_NFS"]),
    ...mapMutations("jobs", ["SET_JOBS"]),
    ...mapMutations("general", ["SET_NOTIFY"]),
    changeMenu(active) {
      this.menu = { ...initMenu };
      this.menu[active] = true;
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
  beforeMount() {
    this.MENU().then(({ data }) => {
      if (data && data.menu)
        data.menu.map(m => this.m.push(m.id_menu.replace('menu-', '')))
    })
  },
  mounted() {
    if (this.user.grupo == "Financeiro") {
      var self = this;
      let count = 0;
      setInterval(function () {
        self.LOAD_NFS({ status: "pendente" }).then((r) => {
          let n = r.data.length;
          if (n > 0 && n > count) {
            count = n;
            self.SET_NOTIFY("Você possui novas notas fiscais para validar.");
          }
        });
      }, 60000);
    }
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.header {
  height: 70px;
  background: #fff;
  box-shadow: 0px 0px 4px rgba($purple, 0.1);
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  @media (max-width: $small) {
    height: 82px;
  }

  .logo {
    width: 163px;
    height: 53px;
    margin-left: 35px;
    display: none;

    &-icon {
      width: 90px;
      margin: auto;
    }
  }

  .menu {
    list-style: none;
    color: $font-color;
    font-size: 12px;
    font-weight: bold;

    &>li {
      @media (max-width: $medium) {
        font-size: 9px;
      }

      a {
        padding: 30px 0px;
        color: $font-color;

        &:hover {
          color: $supporter-1 !important;
        }

        @media (max-width: $medium) {
          font-size: 9px;
        }
      }

      padding: 25px 0px;

      &:hover {
        color: $supporter-1 !important;
        z-index: 999;
        cursor: pointer;

        & ul {
          display: block;

          li {
            padding: 15px 25px;
            text-transform: uppercase;

            &:hover {
              color: $supporter-1;
            }
          }
        }
      }

      ul {
        display: none;
        list-style: none;
        position: absolute;
        background: rgba(#fff, .9);
        margin-top: 38px;
        margin-left: -12px;
        padding: 13px 6px;
        border-radius: 0 0 9px 9px;
        box-shadow: 0px 2px 4px rgba($purple, 0.2);
      }
    }

    .arrow-down {
      margin-left: 10px;
      font-size: 12px;
      color: $purple;
    }

    .active {
      a {
        color: $supporter-1;
      }
    }

    .pendencies {
      & i {
        margin-right: 7px;
        font-size: 14px;
      }

      .ball {
        float: right;
        border-radius: 50%;
        font-size: 12px;
        min-width: 17px;
        height: 17px;
        line-height: 14px;
        font-weight: bold;
        text-align: center;
        margin-top: -30px;
        margin-right: -15px;
        color: $white;
        background: $red-1;
      }
    }

    &-mobile {
      color: #fff;
      font-size: 30px;
      display: none;
      cursor: pointer;

      .menu {
        width: 0%;
        width: 100%;
        background: black;
        position: absolute;
        top: -380%;
        z-index: 990;
        font-size: 20px;
        border-radius: 0 0 21px 21px;

        &.opened {
          top: 80px;
        }

        li {
          padding: 1.6rem 20px;

          a {
            padding: 25px 0px;
          }
        }

        ul {
          padding: 0px;
          width: 100%;

          li {
            padding: 25px 5%;
          }
        }
      }

      button {
        margin: 15% auto;
        display: block;
        width: 45px;
        height: 45px;
        position: relative;
        display: block;
        width: 18px;
        height: 2px;
        background: #fff;
        border-radius: 3px;
        cursor: pointer;
        transition: transform 0.2s ease;

        &::before {
          content: "";
          display: block;
          position: absolute;
          width: 18px;
          height: 2px;
          top: -12px;
          left: 0px;
          background: #fff;
          border-radius: 3px;
          transition: transform 0.3s ease;
        }

        &::after {
          content: "";
          display: block;
          position: absolute;
          width: 18px;
          height: 2px;
          left: 0px;
          top: 12px;
          background: #fff;
          border-radius: 3px;
          transition: transform 0.3s ease;
        }

        &.close {
          left: 5px;
          position: relative;
          display: block;
          width: 0;
          height: 0;
          background: transparent;
          transform: rotate(-180deg);

          &::before {
            content: "";
            display: block;
            position: absolute;
            width: 18px;
            height: 2px;
            top: 0;
            background: #fff;
            transform: rotate(-45deg);
            transition: transform 0.3s ease;
          }

          &::after {
            content: "";
            display: block;
            position: absolute;
            width: 18px;
            height: 2px;
            top: 0;
            background: #fff;
            transform: rotate(45deg);
            transition: transform 0.3s ease;
          }
        }
      }

      i {
        margin-left: 20px;
      }

      & ul {
        @media (max-width: $medium) {
          font-size: 9px;
        }

        .active {
          border-bottom: none;
        }
      }

      & ul li ul {
        display: block;
        position: inherit;
        /* margin-left: -100px;*/

      }

      .pendencies {
        & i {
          margin-right: 7px;
          font-size: 14px;
        }

        .ball {
          float: right;
          border-radius: 50%;
          font-size: 12px;
          min-width: 17px;
          height: 17px;
          line-height: 14px;
          font-weight: bold;
          text-align: center;
          margin-top: -30px;
          margin-right: -15px;
          color: $white;
          background: $red-1;
        }
      }
    }
  }
}
</style>
